import { render, staticRenderFns } from "./OptimizedForUmbrelHomeBadge.vue?vue&type=template&id=7311945c&scoped=true&"
import script from "./OptimizedForUmbrelHomeBadge.vue?vue&type=script&lang=js&"
export * from "./OptimizedForUmbrelHomeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7311945c",
  null
  
)

export default component.exports